/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }

  .loader {
    position: absolute !important;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.6);
    color: #5e5e5e;
    z-index: 2000;    
  }
`;

export const Groupbutton = styled.div`
  margin: 32px auto 0;
  width: 385.14px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  .button-next{
    background: #3C71DD;
    width: 120.14px;
  }
  .button-cancel{
    width: 120.14px;
    background: #AEAEAE;
  }
`;